//@flow
import * as React from 'react';
import {
    MenuPlacementEnum,
    VirtualizedCreatableSelect
} from 'common/components/core/select';
import { memoizedImmutable } from 'common/utils/Memoizer';
import capitalize from 'lodash/capitalize';

export class CitySelector extends React.PureComponent {
    @memoizedImmutable()
    getCitiesOptions(
        cities: Array<CityType>
    ): Array<{ label: string, value: string }> {
        return cities.map(city => {
            const capitalizedCityName = capitalize(city.cityName);
            return {
                label: capitalizedCityName,
                value: capitalizedCityName
            };
        });
    }

    render() {
        const {
            error,
            cities,
            value,
            onBlur,
            onChange,
            formatCreateLabel,
            theme,
            placeholder,
            ...others
        } = this.props;
        const options = cities.data ? this.getCitiesOptions(cities.data) : [];
        return (
            <VirtualizedCreatableSelect
                {...others}
                placeholder={placeholder}
                theme={theme}
                value={value}
                error={error}
                formatCreateLabel={formatCreateLabel}
                onChange={onChange}
                onBlur={onBlur}
                isLoading={cities.isLoading}
                options={options}
                menuPlacement={MenuPlacementEnum.Bottom}
                openMenuOnFocus
                loaderInside
                noMarginBottom
            />
        );
    }
}
export default CitySelector;
